import React, { createContext, useContext, useState, useEffect } from 'react';
import { getFontFromQueryParam, updateCSSFontVariable } from '../utils/fontUtils';

const FontContext = createContext();

export const useFont = () => {
  const context = useContext(FontContext);
  if (!context) {
    throw new Error('useFont must be used within a FontProvider');
  }
  return context;
};

export const FontProvider = ({ children }) => {
  const [currentFont, setCurrentFont] = useState('Rubik');

  // Initialize font from query parameter only (no localStorage persistence)
  useEffect(() => {
    const queryFont = getFontFromQueryParam();
    
    if (queryFont === 'Noto Sans Hebrew') {
      setCurrentFont('Noto Sans Hebrew');
      updateCSSFontVariable('Noto Sans Hebrew');
    } else {
      // Default to Rubik if no query parameter or different parameter
      setCurrentFont('Rubik');
      updateCSSFontVariable('Rubik');
    }
  }, []);

  const changeFont = (font) => {
    setCurrentFont(font);
    updateCSSFontVariable(font);
  };

  const value = {
    currentFont,
    changeFont,
  };

  return (
    <FontContext.Provider value={value}>
      {children}
    </FontContext.Provider>
  );
}; 